var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',_vm._g(_vm._b({},'el-tooltip',_vm.attrs,false),_vm.listeners),[(_vm.$slots.content)?_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("content")],2):_vm._e(),_c('wx-calc-ellipsis',{ref:"WxCalcEllipsis",nativeOn:{"mouseenter":function($event){return _vm.handleCalcToolTip.apply(null, arguments)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }